// import timeout from "./service.js"
import { Toast } from "vant"
const timeout = 3000
// 接口调用时,可选择使用Loading对话框
export const showLoadingToast = (durationTime = timeout) => {
  Toast.loading({
    message: "Loading...",
    forbidClick: true,
    loadingType: "spinner",
    duration: durationTime
  })
}

// 接口调用时, 将URL前添加一层 "/api" 路径
export const addApiPathFor = url => {
  return "/api" + url
}

// 接口调用时,临时添加Token字段到数据体中
export const addTokenToData = data => {
  const token = localStorage.getItem("token")
  if (token && token.length > 0) {
    return { ...data, token }
  }
  return data
}



// WEBPACK FOOTER //
// ./src/api/utils.js